import { doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { app } from '../../util/firebase';

const UpdateClient = (props) => {
    
    const [name,setName] = useState("")
    const [adresse,setAdresse] = useState("")
    const [number,setNumber] = useState("")
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [currentUser,setCurrentUser] = useState(null)
    const [img,setImg] = useState(null)
    const [isChecked,setIsChecked] = useState(false)

    const navigate = useNavigate()

    useEffect(()=>{
        onSnapshot(doc(getFirestore(app),"users",props.clientID),(snap)=>{
            let client = snap.data()
            setCurrentUser(client)
            setName(client.userName)
            setAdresse(client.adresse)
            setEmail(client.email)
            setPassword(client.password)
            setNumber(client.phoneNumber)
            setIsChecked(true)
            
        })
    },[])
    const submit = (e)=>{
        e.preventDefault()

        let user = currentUser
        user.userName = name
        user.phoneNumber = number
        user.adresse = adresse

        if(isChecked===true){
            setDoc(doc(getFirestore(app),"users",props.clientID),user)
            .then(result=>{
                alert('Les changement sont pris en compte')
                navigate(-1)
            })
            .catch(err=>alert(err))
        }else{
            let imgUrl = user.imgSrc.substring(72,user.imgSrc.length - 10)
            imgUrl = imgUrl.replaceAll("%2F","/")
    
            let storageRef = ref(getStorage(app),imgUrl)
            uploadBytes(storageRef,img)
            .then((result)=>{
                setDoc(doc(getFirestore(app),"users",props.clientID),user)
                .then(result=>{
                    alert('Les mises a jours sont pris en compte')
                    navigate(-1)
                })
                .catch(err=>alert(err))
            })
            .catch(err=>alert(err))
        }
    }
    const archiveUser = ()=>{
        let user = currentUser
        user.isArchived = true
        setDoc(doc(getFirestore(app),"users",props.clientID),user)
        .then((result)=>{
            alert('Le client '+currentUser.userName+' a bin été archivé')
            navigate(-1)
        })
    }
    return (
        <div>
            <div>
                <div className='col-12 col-md-6 m-auto shadow p-3 my-3 my-md-5 '>
                    <h2 className='text-center'>Mettre a jours les données du client</h2>
                    <form onSubmit={e=>submit(e)}>
                        <input required className='form-control my-3' type="text" placeholder='Nom de la pharmacie' value={name} onChange={e=>setName(e.target.value)}></input>
                        <input required className='form-control my-3' type="text" placeholder='Addresse' value={adresse} onChange={e=>setAdresse(e.target.value)}></input>
                        <input required className='form-control my-3' type="number" placeholder='Numéro de téléphone' value={number} onChange={e=>setNumber(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="email" placeholder='Email' value={email} onChange={e=>setEmail(e.target.value)}></input>
                        <input disabled required className='form-control my-3' type="password" placeholder='Mot de passe' value={password} onChange={e=>setPassword(e.target.value)}></input>
                        <label className='row p-3'>
                            <div className='col-9'>
                                <input type="checkbox" checked={isChecked} onChange={e=>setIsChecked(!isChecked)}></input>
                                Garder l'image actuel
                            </div>

                            {isChecked? (<div className='col-3' style={{minHeight:'94px',backgroundImage:'url('+currentUser.imgSrc+')',backgroundSize:'cover',backgroundPosition:'center'}}></div>) :(null)}
                        </label>
                        {isChecked? (null) :(<input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>)}
                        <button className='btn btn-primary col-12'>Mettre a jours</button>
                        <button type='button' className='btn btn-danger col-12 my-2' onClick={archiveUser}>Archiver ce client</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateClient;